module.exports = __webpack_public_path__ + "img/20190528162641QQ截图20190527165122.35d91ced.png";